/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntermediaryAssociatesViewModel } from './IntermediaryAssociatesViewModel';
import {
    IntermediaryAssociatesViewModelFromJSON,
    IntermediaryAssociatesViewModelFromJSONTyped,
    IntermediaryAssociatesViewModelToJSON,
} from './IntermediaryAssociatesViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfListOfIntermediaryAssociatesViewModel
 */
export interface ResultOfListOfIntermediaryAssociatesViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfListOfIntermediaryAssociatesViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfIntermediaryAssociatesViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfIntermediaryAssociatesViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfIntermediaryAssociatesViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfIntermediaryAssociatesViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfListOfIntermediaryAssociatesViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfListOfIntermediaryAssociatesViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<IntermediaryAssociatesViewModel>}
     * @memberof ResultOfListOfIntermediaryAssociatesViewModel
     */
    data?: Array<IntermediaryAssociatesViewModel>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfIntermediaryAssociatesViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfListOfIntermediaryAssociatesViewModel interface.
 */
export function instanceOfResultOfListOfIntermediaryAssociatesViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfListOfIntermediaryAssociatesViewModelFromJSON(json: any): ResultOfListOfIntermediaryAssociatesViewModel {
    return ResultOfListOfIntermediaryAssociatesViewModelFromJSONTyped(json, false);
}

export function ResultOfListOfIntermediaryAssociatesViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfListOfIntermediaryAssociatesViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(IntermediaryAssociatesViewModelFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfListOfIntermediaryAssociatesViewModelToJSON(value?: ResultOfListOfIntermediaryAssociatesViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(IntermediaryAssociatesViewModelToJSON)),
        'Count': value.count,
    };
}

